import master from "../_ApiConn/apiMaster";


const getMaster = async () => {
    
    let dFromF = await master.getMaster();
    return (dFromF.data[0]);
}

const getMainMenu = async () => {
    
    let dFromF = await master.getMainMenu();
    return (dFromF.data);
}

export default {
    getMainMenu,
    getMaster
};